module.exports = __webpack_public_path__ + "img/icon_like.9e3e0be4.svg";